import { useState, useEffect } from 'react';
import { fetchGeolocation, submitLead } from '../utils/api';
import { getDialCodeFromCountry } from '../utils/countryMapping';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validate form fields before submission.
 * Returns error message string or null if valid.
 */
const validateForm = (formData) => {
  if (!formData.email || !EMAIL_REGEX.test(formData.email)) {
    return 'Please enter a valid email address (e.g., user@example.com).';
  }

  const digits = (formData.contactNumber || '').replace(/\D/g, '');
  if (!digits || digits.length !== 10) {
    return 'Please enter a valid 10-digit phone number.';
  }

  return null;
};

/**
 * Single hook for all lead forms across the website.
 */
export const useLeadForm = () => {
  const [geo, setGeo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchGeolocation().then((data) => { if (data) setGeo(data); });
  }, []);

  const submitForm = async (formData, extras = {}) => {
    setError(null);

    // Client-side validation
    const validationError = validateForm(formData);
    if (validationError) {
      setError(validationError);
      return { success: false, message: validationError };
    }

    setIsLoading(true);
    const result = await submitLead(formData, geo, extras);

    if (result.success) {
      if (result.customerId) {
        window.location.href = `/application/main?customerid=${result.customerId}`;
      }
    } else {
      setError(result.message);
    }

    setIsLoading(false);
    return result;
  };

  return { geo, isLoading, error, submitForm, clearError: () => setError(null) };
};
